<!--
 * @Description: 银行电子户信息
 * @Date: 2025-05-20 18:01:30
-->

<template>
  <div class="account-info__items">
    <BaseTextTitle class="account-info__items__title">
      银行电子户信息
    </BaseTextTitle>
    <BaseTextContent>
      <BaseFormItem
        label="户名"
        prop="openName"
        :rules="[
          {
            required: true,
            trigger: 'change',
            message: '请输入'
          }
        ]"
      >
        <BaseInput
          type="text"
          placeholder="请输入"
          v-model="formData.openName"
        ></BaseInput>
      </BaseFormItem>
      <BaseFormItem
        label="开户行"
        prop="openBankNumber"
        :rules="[
          {
            required: true,
            trigger: 'change',
            message: '请输入'
          }
        ]"
      >
        <BaseInput
          type="tel"
          placeholder="请输入"
          clearable
          v-model="formData.openBankNumber"
        ></BaseInput>
      </BaseFormItem>
      <BaseFormItem
        label="账号"
        prop="openBankNumber"
        :rules="[
          {
            required: true,
            trigger: 'change',
            message: '请输入'
          }
        ]"
      >
        <BaseInput
          type="tel"
          placeholder="请输入"
          clearable
          v-model="formData.openBankNumber"
        ></BaseInput>
      </BaseFormItem>
    </BaseTextContent>
  </div>
</template>

<script lang="ts" setup>
import {
  BaseFormItem,
  BaseInput,
  BaseTextContent,
  BaseTextTitle
} from 'xrk-components';
import { storeToRefs } from 'pinia';
import infoStore from '../../store/info';

const { formData } = storeToRefs(infoStore());
</script>
